import React from 'react'
import { useTranslate } from 'react-admin'
import {
  TooltipContainer,
  TooltipDescriptionCell,
  TooltipFooter,
  TooltipHeader,
  TooltipLabel,
  TooltipRow,
  TooltipTable,
} from '../ProjectConfigurations.styles'

export const BatteryEndOfLifeDefinitionTooltip: React.FC = () => {
  const translate = useTranslate()

  const options = [
    {
      label: translate('Calendar & Cycle Count'),
      description: translate(
        'Battery reaches end of life when either the calendar age limit OR the cycle count limit is reached, whichever comes first.'
      ),
    },
    {
      label: translate('Cycle Count Only'),
      description: translate(
        'Battery reaches end of life based solely on the number of charge/discharge cycles, regardless of calendar age.'
      ),
    },
    {
      label: translate('Calendar Only'),
      description: translate(
        'Battery reaches end of life based solely on calendar age (years), regardless of how many cycles it has completed.'
      ),
    },
    {
      label: translate('End of Life Years Override'),
      description: translate(
        'Use a fixed number of years to determine end of life, overriding both calendar and cycle count calculations.'
      ),
    },
  ]

  return (
    <TooltipContainer>
      <TooltipHeader>{translate('Battery End of Life Definition Options:')}</TooltipHeader>
      <TooltipTable>
        {options.map((option, index) => (
          <TooltipRow key={index}>
            <TooltipLabel>{option.label}</TooltipLabel>
            <TooltipDescriptionCell>{option.description}</TooltipDescriptionCell>
          </TooltipRow>
        ))}
      </TooltipTable>
      <TooltipFooter>
        {translate(
          'The end of life definition determines when the battery is considered to have reached its end of life threshold. This affects when replacement occurs and how degradation is calculated over the system lifetime.'
        )}
      </TooltipFooter>
    </TooltipContainer>
  )
}
